import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsAvatar from './components/Settings/SettingsAvatar'
import SettingsStep from './components/Settings/SettingsStep'

import {
  setTitle
} from 'common/redux/root'

import {
  saveAvatar, updateAvatar, removeAvatar, fetchSettings
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
  dispatch
})

const noRedirect = location.href.includes('facebookdirect')

class SettingsAvatarContainer extends Component {

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(setTitle("My Avatar"))
    if (noRedirect) {
      this.props.dispatch(fetchSettings())
    }
  }

  handleSubmit(cb) {
    if (this.props.settings.image_path) {
      this.props.dispatch(saveAvatar(this.props.settings.image_path))
        .then(() => cb())
    } else {
      this.props.dispatch(removeAvatar())
        .then(() => cb())
    }
  }

  handleSelect(key) {
    this.props.dispatch(updateAvatar(key))
  }

  render() {
    return <SettingsStep noRedirect={noRedirect} onSubmit={this.handleSubmit} {...this.props}>
      <SettingsAvatar onSelect={this.handleSelect} {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ settings: state.settings }), mapDispatchToProps)(SettingsAvatarContainer)